import { render, staticRenderFns } from "./OtherAssetsList.vue?vue&type=template&id=52463212"
import script from "./OtherAssetsList.vue?vue&type=script&lang=js"
export * from "./OtherAssetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports